import * as React from 'react'

import { CmsPageLayout } from '@grandvision/bloomreach'
import { CartButton as CartButtonV2 } from '@grandvision/carts-v2'
import { CartButton } from '@grandvision/common'
import { MenuItemType } from '@grandvision/layout'

import { isCartV2Enabled } from '../util/feature-toggle'

type LayoutProps = React.ComponentProps<typeof CmsPageLayout>

export const layoutProps: Pick<LayoutProps, 'renderCartButton' | 'useCookieBar'> = {
  useCookieBar: false,
  renderCartButton: (item: MenuItemType) => {
    const props = {
      key: item.label,
      label: item.label,
      href: item.link?.href,
      className: 'header-menu__icon',
    }
    return isCartV2Enabled() ? <CartButtonV2 {...props} /> : <CartButton {...props} />
  },
}
